import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

type Props = {
    title: string;
};

const ModalTitle = ({ title }: Props): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <Typography sx={{ mt: '1rem', mx: '1rem' }}>
            <Box component="span" sx={{ fontWeight: 'bold', mr: '10px' }}>{`${t(
                'rawDataModal.title',
            )} :`}</Box>
            {title}
        </Typography>
    );
};

const MemoModalTitle = React.memo<Props>(ModalTitle);
export default MemoModalTitle;
